import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white from-red-600 to-purple-600 text-black border-t-2 border-gray-300 py-10">
      <div className="flex flex-col items-center gap-4">
        <div className="flex space-x-4">
          <a
            href="https://www.facebook.com/people/Vikingknives/100021421342443"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Facebook
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Twitter
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Instagram
          </a>
          <a
            href="https://snapchat.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Snapchat
          </a>
        </div>
        <p className="text-sm">
          © {new Date().getFullYear()} Viking Knives. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;